module.exports = __webpack_public_path__ + "static/img/avatar-tchat.17b08a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/companies/default/img/avatar-tchat.png
// module id = Yxuh
// module chunks = 1